var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-decision-button"},[_c('button',{staticClass:"base-decision-button-class",attrs:{"type":"button","disabled":_vm.disabled || _vm.preventContinuousClickFlg,"data-e2e":"base-decision-button"},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"base-decision-button-text"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }